import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { LocalNotifications } from '@capacitor/local-notifications';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare let MCCordovaPlugin: any;

type NotificationType = {
  url: string;
  type: string;
};

if (Capacitor.isNativePlatform()) {
  MCCordovaPlugin?.setOnUrlActionListener((notification: NotificationType) => {
    if (notification.type === 'urlAction') {
      const { url } = notification;

      if (url.includes('http')) {
        Browser.open({ url });
      } else if (url.includes('reporting') || url.includes('formation') || url.includes('profile')) {
        window.location.href = url;
      } else {
        window.location.href = '/home';
      }
    }
  });
}
const addTag = (tag: string) => {
  MCCordovaPlugin?.addTag(tag, (result: any) => console.log('PUSH TAG add success:', result), (error: any) => console.log('PUSH TAG add error:', error));
};

const removeTag = (tag: string) => {
  MCCordovaPlugin?.removeTag(tag, (result: any) => console.log('PUSH TAG remove success:', result), (error: any) => console.log('PUSH TAG remove error:', error));
};

const getToken = () => {
  MCCordovaPlugin?.getSystemToken((result: any) => console.log('PUSH token get success:', result), (error: any) => console.log('PUSH Tag get error:', error));
};

const getTags = (callback: (tags: any) => any) => {
  MCCordovaPlugin?.addTag(callback, (error: any) => console.log('PUSH Tag get error:', error));
};

const setContactKey = (contactKey?: string) => {
  MCCordovaPlugin?.setContactKey(contactKey ?? '', (result: any) => console.log('PUSH CONTACT_KEY set success:', result), (error: any) => console.log('PUSH CONTACT_KEY set error:', error));
};

const enableNotifications = (): Promise<boolean> => new Promise((resolve) => {
  const username = localStorage.getItem('username');
  if (username) {
    LocalNotifications.requestPermissions().then((permissions) => {
      if (permissions.display === 'granted') {
        MCCordovaPlugin?.enablePush((response: any) => {
          console.log('PUSH enable success:', response);
          localStorage.setItem('enabledNotifications', 'true');
          resolve(true);
        }, (error: any) => {
          console.log('PUSH enable error:', error);
        });
        getToken();
        setContactKey(username.slice(3));

        const pushLocalConfig = JSON.parse(localStorage.getItem(`pushConfig_${username}`) ?? 'null');
        if (!pushLocalConfig) {
          localStorage.setItem(`pushConfig_${username}`, JSON.stringify({
            discounts: true, offers: true, newCampaigns: true, newProducts: true,
          }));
          addTag('discounts');
          addTag('offers');
          addTag('newCampaigns');
          addTag('newProducts');
        } else {
          Object.keys(pushLocalConfig).forEach((key) => {
            if (pushLocalConfig[key]) {
              addTag(key);
            } else {
              removeTag(key);
            }
          });
        }
      }
    });
  }
});

const disableNotifications = (): Promise<boolean> => new Promise((resolve) => {
  MCCordovaPlugin?.disablePush(() => {
    localStorage.setItem('enabledNotifications', 'false');
    resolve(false);
  }, (error: any) => {
    resolve(true);
    console.log('PUSH disable error:', error);
  });
});

const hasEnabledNotifications = () => localStorage.getItem('enabledNotifications') === 'true';

export const hasNotificationsPermissions = (): Promise<boolean> => new Promise(
  (resolve) => {
    LocalNotifications.checkPermissions().then((permissions) => {
      if (permissions.display === 'granted') {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  },
);

export const canRequestPermissions = (withRationale?: boolean): Promise<boolean> => new Promise(
  (resolve) => {
    LocalNotifications.checkPermissions().then((permissions) => {
      if (permissions.display === 'prompt' || (withRationale && permissions.display === 'prompt-with-rationale')) {
        resolve(true);
      } else {
        resolve(false);
      }
    });
  },
);

export const checkNotifications = (): Promise<boolean> => new Promise((resolve, reject) => {
  try {
    if (MCCordovaPlugin) {
      const username = localStorage.getItem('username');

      if (username) {
        MCCordovaPlugin.isPushEnabled(
          (enabled: boolean) => {
            resolve(enabled);
          },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (error: any) => {
            // eslint-disable-next-line no-console
            console.error('Error checking notifications state', error);
            reject(error);
          },
        );
      }
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log('Error enabling notifications', error);
    reject(error);
  }
});

export const notificationService = {
  enableNotifications,
  disableNotifications,
  getToken,
  getTags,
  addTag,
  removeTag,
  setContactKey,
  hasEnabledNotifications,
  canRequestPermissions,
};
